const Steps = ({ currentStep }) => {
  const stepsOrder = ["Loans", "Application", "Score", "Review", "Underwrite"];

  const isStepCompleted = (step) =>
    stepsOrder.indexOf(currentStep) >= stepsOrder.indexOf(step);

  return (
    <ul className="steps mt-4 pb-4">
      {stepsOrder.map((step) => (
        <li
          key={step}
          className={isStepCompleted(step) ? "completed" : undefined}
        >
          <span></span>
          <div style={{ fontSize: 20 }}>{step}</div>
        </li>
      ))}
    </ul>
  );
};

export default Steps;
